// We haven't added icon's computed property because it makes this mixin coupled with UI
export const togglePasswordVisibility = {
  data() {
    return {
      passwordFieldType: "password",
      cpasswordFieldType: "password",
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    toggleCpasswordVisibility() {
      this.cpasswordFieldType =
        this.cpasswordFieldType === "password" ? "text" : "password";
    },
  },
};

export const _ = null;
